import { connect } from 'react-redux';
import { Action, bindActionCreators } from 'redux';
import {
    changeDashboardFilter,
    getDashboardFilters,
} from './dashboard-filters.state';
import { DashboardFiltersProps } from './dashboard-filters.types';

export interface WithDashboardFilters {
    dashboardFilters:DashboardFiltersProps;
    onChangeDashboardFilter: (params: Partial<DashboardFiltersProps>) => Action
}

export const withDashboardFilters = connect(
    state => ({
        dashboardFilters: getDashboardFilters(state),
    }),
    dispatch => bindActionCreators({
        onChangeDashboardFilter: changeDashboardFilter,
    }, dispatch),
);
